import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';
import RecursoEdit from '../paginas/EscritorioProjetos/Recurso/Edit';

@autobind
class RecursoLookup extends React.Component {
  render() {
    return (
      <Lookup
        labelKey="nome"
        valueKey="id"
        url="/RecursoLookup"
        editComponent={RecursoEdit}
        {...this.props}
      />
    );
  }
}

export default RecursoLookup;
